export const headerProductNavigation = {
  initial: 'idle',
  states: {
    idle: {
      always: [
        {
          target: 'on',
          cond: 'isKrakenEnabled',
        },
        {
          target: 'off',
        },
      ],
    },
    on: {
      invoke: {
        src: 'watchHeaderProductNavigationActions',
      },
      on: {
        VIEW_HEADER_PRODUCT_EVENT_CALLED: {
          actions: ['trackRedirectToProduct', 'initiateRedirectWithDelay'],
        },
        REDIRECT_TO_PRODUCT: {
          actions: 'redirectToProductPage',
        },
      },
    },
    off: {},
  },
};
